import { i18n } from "@v2/shared/config";

export const pluralize = (number, words) => {
  if (i18n.locale === "en") {
    return number === 1 ? words[0] : words[1];
  }

  const cases = [2, 0, 1, 1, 1, 2];

  return words[
    number % 100 > 4 && number % 100 < 20 ? 2 : cases[Math.min(number % 10, 5)]
  ];
};
